enum OAuthDialogFields {
	DISPLAY_NAME = "display_name",
	CLIENT_ID = "client_id",
	APPLICATION_ID = "application_id",
	TENANT_ID = "tenant_id",
	SCOPE = "scope",
	DISCOVERY_URL = "discovery_url",
	LOGOUT = "logout",
	CLAIM_CLIENT_ID = "claim_client_id",
	CLAIM_SESSION_ID = "claim_session_id",
	CLAIM_ROLES = "claim_roles",
	ROLE_ADMIN = "role_admin",
	ROLE_USER = "role_user"
}

export default OAuthDialogFields;